import Vue from 'vue'
import Vuex from 'vuex'
import orders from '@/store/orders.module'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export const store =  new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.localStorage
    })],
    modules: {
        orders
    },
    strict: debug
})